import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'cc-settings-header',
  templateUrl: './settings-header.component.html',
  styleUrls: ['./settings-header.component.scss']
})
export class SettingsHeaderComponent implements OnInit {
  @Input() header: string;

  constructor() {}

  ngOnInit() {}
}
